import { SensorsApiFactory, V1Sensor, V1SensorStatus } from '@vacancorp/enterprise-for-client.vacanservice.com'
import { Sensor, SensorDetails, SensorStatus } from '@/models'
import { api, ApiResponse, ListResponse, createApiError } from './base'
import { HashUtil } from "@/utils/hash";

function convertSensorStatus(rawSensorStatus?: V1SensorStatus): SensorStatus {
  switch (rawSensorStatus) {
    case V1SensorStatus.UNKNOWNSENSORSTATUS:
      return SensorStatus.UNKNOWNSENSORSTATUS
    case V1SensorStatus.UNINITIALIZED:
      return SensorStatus.UNINITIALIZED
    case V1SensorStatus.RUNNING:
      return SensorStatus.RUNNING
    case V1SensorStatus.SUSPENDED:
      return SensorStatus.SUSPENDED
    default:
      return SensorStatus.UNKNOWNSENSORSTATUS
  }
}

function createSensors(rawSensors?: V1Sensor[]): Sensor[] {
  if (!rawSensors) return [] as Sensor[]

  const sensorHashUtil = new HashUtil("sensor");

  return rawSensors.map((s: V1Sensor): Sensor => {
    return new Sensor({
      id: s.id,
      databaseId: s.id !== undefined ? sensorHashUtil.idFromHash(s.id) : undefined,
      mac: s.mac,
      sensorType: s.sensorType,
      companyId: s.companyId,
      details: new SensorDetails({
        battery: s.details?.battery,
        latestDateTime: s.details?.latestDataTime,
        status: convertSensorStatus(s.details?.status)
      })
    })
  })
}

export const NewSensorsApiFunc = () => {
  const webAdapter = SensorsApiFactory(undefined, api.defaults.baseURL, api)

  return {
    adminUnassignSensor: async (companyId: string, sensorId: string): Promise<ApiResponse<void>> => {
      let data, err

      try {
        await webAdapter.adminDeleteSensor(companyId, sensorId)
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    adminGetSensor: async (companyId: string, sensorId: string): Promise<ApiResponse<Sensor | undefined>> => {
      let data, err

      try {
        const res = await webAdapter.adminGetSensor(companyId, sensorId)
        data = createSensors([res.data])[0]
      } catch (e) {
        err = e
      }

      return {
        data,
        err,
      }
    },

    listSensors: async (companyId: string, filter?: string, page?: number, isInstalled?: boolean): Promise<ApiResponse<ListResponse<Sensor>>> => {
      let data, currentPage, totalPage, err

      try {
        const res = await webAdapter.listSensors(companyId, filter, page, isInstalled)
        if (res.data === null) {
          data = [] as Sensor[];
          currentPage = 0;
          totalPage = 0;
        } else {
          data = createSensors(res.data.sensors)
          currentPage = res.data.currentPage
          totalPage = res.data.totalPage
        }
      } catch (e) {
        data = [] as Sensor[]
        err = createApiError(e)
      }

      return {
        data: {
          list: data,
          currentPage: currentPage || 1,
          totalPage: totalPage || 1
        },
        err,
      }
    }
  }
}